import Link from "next/link";
import type { ReactNode } from "react";

import { FOCUS_TERMS_OF_SERVICE_URL } from "@/utils/constants";
import { cn } from "@/utils/lib";

import { Checkbox } from "../ui/checkbox";
import { Label } from "../ui/label";

export const isTestNet = process.env.NEXT_PUBLIC_IS_TESTNET === "true";

export const testnetInitialAgreed = {
  testnet: false,
  loseMoney: false,
  noSend: false,
  serious: false,
};

export const initialAgreed = {
  ...(isTestNet ? testnetInitialAgreed : {}),
  terms: false,
};

type CheckboxListType = {
  id: keyof typeof initialAgreed;
  label: ReactNode;
}[];

const testnetCheckboxes: CheckboxListType = [
  {
    id: "testnet",
    label:
      "I understand this app is running on testnet, meaning it DOES NOT USE REAL MONEY.",
  },
  {
    id: "loseMoney",
    label: "I will LOSE any real money I send to this app.",
  },
  {
    id: "noSend",
    label: "I will not send real money to this app.",
  },
  {
    id: "serious",
    label: "Seriously, though, DON'T SEND REAL MONEY TO THIS APP!",
  },
];

export const checkboxes: CheckboxListType = [
  ...(isTestNet ? testnetCheckboxes : []),
  {
    id: "terms",
    label: (
      <>
        I have read, understood, and agree to be bound by the{" "}
        <Link
          href={FOCUS_TERMS_OF_SERVICE_URL}
          target="_blank"
          className="
            underline underline-offset-4
            hover:underline
          "
        >
          Terms of Service
        </Link>
        .
      </>
    ),
  },
];

export const TermsOfService = ({
  agreed,
  onAgreedChange,
  labelClassName,
  wrapperClassName,
}: {
  agreed: Record<string, boolean>;
  onAgreedChange: (
    key: keyof typeof initialAgreed,
  ) => (checked: boolean) => void;
  labelClassName?: string;
  wrapperClassName?: string;
}) => {
  return (
    <div
      className={cn(
        `
          mb-8 flex w-full cursor-pointer flex-col rounded-sm border
          border-border p-2
          sm:rounded-full sm:p-0
        `,
        wrapperClassName,
      )}
    >
      {checkboxes.map((checkbox) => (
        <div
          key={checkbox.id}
          className="
            border-b-light flex items-start gap-0 border-b pl-2 text-muted
            first:rounded-t-2xl
            last:rounded-b-2xl last:border-b-0
            hover:bg-card hover:text-muted-foreground
          "
          onClick={() => {
            onAgreedChange(checkbox.id)(!agreed[checkbox.id]);
          }}
        >
          <Checkbox
            id={checkbox.id}
            className="relative top-[10px]"
            checked={agreed[checkbox.id]}
          />
          <Label
            className={cn(
              `
                w-full p-2 pr-4 text-left leading-5 text-muted
                hover:text-muted-foreground
              `,
              labelClassName,
            )}
          >
            {checkbox.label}
          </Label>
        </div>
      ))}
    </div>
  );
};
